import {Component, HostBinding, HostListener, Inject, LOCALE_ID, OnInit,} from '@angular/core';
import {GfxStoreService} from './services/gfx.store.service';
import {Router} from '@angular/router';
import {SharingDataService} from './services/sharing-data.service';
import {MSG_SUCCESS, MSG_SUCCESS_DEL} from './enums/constants';
import {CoreService} from './layouts/themes-strategies/vuely-strategy/admin-vuely-layout/comp/Core.service';
import {AuthService} from './services/auth.service';
import {Subscription} from 'rxjs';
import {IUser} from './models/IUser';
import {UserProfileEnum} from './pages/inscription/enums/user-profile.enum';
import {GfxHttpSrv} from './services/GfxHttpSrv';
import menusUrl from '../environments/urlsBe.json';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
    title = 'app';
    private authSubscription: Subscription;

    constructor(
        private store: GfxStoreService,
        private router: Router,
        public sharing: SharingDataService,
        private authService: AuthService,
        @Inject(LOCALE_ID) private locale: string,
        public coreService: CoreService,
        private http: GfxHttpSrv,
    ) {
    }

    // Implemented languages

    @HostBinding('attr.dir') dir = 'ltr';

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        // this.userSrv.getCurrProfil().subscribe((retour) => {
        //     sessionStorage.setItem(
        //         'profile',
        //         JSON.stringify({id: retour.idCurrProfil, itemName: retour.lib})
        //     );
        // });

        const currentUser = this.store.getCurrUser();
        if (currentUser) {
            // const userWithoutToken = {
            //     current_role_name: currentUser.current_role_name,
            //     nomPrenom: currentUser.nomPrenom
            // };

            const userWithoutToken = {...currentUser};
            delete userWithoutToken.access_token;
            delete userWithoutToken.expires_in;
            delete userWithoutToken.firstAccess;
            delete userWithoutToken.token_type;

            sessionStorage.setItem('user', JSON.stringify(userWithoutToken));
        } else {
            if (sessionStorage.getItem('user')) {
                sessionStorage.removeItem('user');
            }
        }


    }

    ngOnInit(): void {
        // this.http
        //     .get(menusUrl.menuList)
        //     .subscribe((menu) => {
        //         this.store.changeMenus(menu);
        //     });

        // this.authSubscription = this.authService.currentUser$.subscribe((user) => {
        //     this.updateMenu(user);
        // });
        this.router.events.subscribe((data) => {
            if (!this.store.central_msg_success) {
                this.store.central_msg_success = MSG_SUCCESS;
            }
            if (!this.store.central_msg_success_del) {
                this.store.central_msg_success_del = MSG_SUCCESS_DEL;
            }
        });

        if (this.locale.startsWith('ar')) {
            const body = document.getElementsByTagName('body')[0];

            this.coreService.layout = 'rtl';
            this.coreService.rtlStatus = true;
            body.classList.add('rtl-layout');

            // this.dir = 'rtl';

            body.classList.add('rtl-active');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
        }
    }

    updateMenu(user: any) {
        let staticMenu = [
            {
                children: null,
                collapse: 'recette',
                displIndex: null,
                faIcon: 'fa-home', // Icône Font Awesome pour l'accueil
                icontype: 'fa', // Type d'icône (fa pour Font Awesome)
                isCollapsed: true,
                mdicon: null,
                path: '/home',
                title: 'Accueil',
                type: 'link',
            },
            {
                children: [
                    {
                        path: 'renouvellementPasseport',
                        ab: 'AB',
                        faIcon: 'fa-passport', // Icône pour renouvellement passeport
                        title: 'Renouveler votre passeport',
                    },
                    {
                        path: 'verifRen',
                        ab: 'AB',
                        faIcon: 'fa-search', // Icône pour suivre demande
                        title: 'Suivre votre demande',
                    },
                ],
                collapse: 'recette',
                displIndex: null,
                faIcon: 'fa-passport', // Icône principale pour passeport
                icontype: 'fa',
                isCollapsed: true,
                mdicon: null,
                path: 'passeport',
                title: 'Passeport',
                type: 'sub',
            },
            {
                children: [
                    {
                        path: 'demande-cnie/cnie-process',
                        ab: 'AB',
                        faIcon: 'fa-id-card', // Icône pour demande CNIE
                        title: 'Demander votre CNIE',
                    },
                    {
                        path: 'verifRen',
                        ab: 'AB',
                        faIcon: 'fa-search', // Icône pour suivre demande
                        title: 'Suivre votre demande',
                    },
                ],
                collapse: 'recette',
                displIndex: null,
                faIcon: 'fa-id-card', // Icône principale pour CNIE
                icontype: 'fa',
                isCollapsed: true,
                mdicon: null,
                path: 'cnie',
                title: 'CNIE',
                type: 'sub',
            },
            {
                children: null,
                collapse: 'recette',
                displIndex: null,
                faIcon: 'fa-address-card', // Icône pour carte de séjour
                icontype: 'fa',
                isCollapsed: true,
                mdicon: null,
                path: 'carte-sejour',
                title: 'Carte de séjour',
                type: 'link',
            },
            {
                children: null,
                collapse: 'recette',
                displIndex: null,
                faIcon: 'fa-globe', // Icône pour e-Visa
                icontype: 'fa',
                isCollapsed: true,
                mdicon: null,
                path: this.getEVisaPath(),
                title: `e-Visa Touristique`,
                type: 'link',
            },
            {
                children: [
                    {
                        path: 'reclamation',
                        ab: 'AB',
                        faIcon: 'fa-exclamation-circle', // Icône pour réclamation
                        title: 'Procéder à une réclamation',
                    },
                    {
                        path: 'verifRec',
                        ab: 'AB',
                        faIcon: 'fa-search', // Icône pour suivre réclamation
                        title: 'Suivre votre réclamation',
                    },
                ],
                collapse: 'recette',
                displIndex: null,
                faIcon: 'fa-exclamation-circle', // Icône principale pour réclamation
                icontype: 'fa',
                isCollapsed: true,
                mdicon: null,
                path: 'reclamation/reclam',
                title: 'Réclamation',
                type: 'sub',
            },
            {
                children: [
                    {
                        path: 'apropos',
                        ab: 'AB',
                        faIcon: 'fa-info-circle', // Icône pour à propos
                        title: 'A propos'
                    },
                    {
                        path: 'aide',
                        ab: 'AB',
                        faIcon: 'fa-question-circle', // Icône pour aide
                        title: 'Aide'
                    },
                ],
                collapse: 'recette',
                displIndex: null,
                faIcon: 'fa-question-circle', // Icône principale pour aide
                icontype: 'fa',
                isCollapsed: true,
                mdicon: null,
                path: 'aide',
                title: 'Aide',
                type: 'sub',
            },
        ];

        this.store.changeMenus(staticMenu);
    }

    // getEVisaPath(): string {
    //   const user: IUser = this.store.getCurrUser();
    //   if (!user) return "e-visa-steps";
    //
    //   switch (user.idProfile) {
    //     case UserProfileEnum.PORTAL_VISA:
    //       return "e-visa";
    //     case UserProfileEnum.PORTAL_STRUCTURE:
    //       return "espace-structure";
    //     case UserProfileEnum.PORTAL_CONTACT:
    //       return "espace-contact";
    //     default:
    //       return "e-visa";
    //   }
    // }
    getEVisaPath(): string {
        const user: IUser = this.store.getCurrUser();
        if (!user) {
            return 'e-visa-steps';
        }

        switch (user.current_role_name) {
            case UserProfileEnum.PORTAL_VISA_ROLE:
                return 'e-visa';
            case UserProfileEnum.PORTAL_STRUCTURE_ROLE:
                return 'espace-structure';
            case UserProfileEnum.PORTAL_CONTACT_ROLE:
                return 'espace-contact';
            default:
                return 'e-visa';
        }
    }

    @HostListener('wheel', ['$event']) onMouseWheel(event: any) {
        if (event.srcElement.type === 'number') {
            event.preventDefault();
        }
    }
}
